






































































































































































































































































import { genericErrorMessage } from '@/constants'
import { dataSyncService } from '@/services'
import { DataSyncMetadata, DataSyncMetadataGroup } from '@/types/DataSyncServiceType'
import { debounce } from 'lodash'
import Vue from 'vue'

function generateUpsertInitialDataSourceForm() {
    return {
        dialog: false,
        source: '',
        step: 1,
        steps: {
            1: {error: '', loading: false, success: false},
            2: {error: '', loading: false, success: false},
            3: {error: '', loading: false, success: false}
        },
        dataSyncData: {source: '', availableData: [], syncedData: []} as DataSyncMetadataGroup,
        originalSyncedData: [] as DataSyncMetadata[]
    }
}

export default Vue.extend({
    name: 'DataSync',
    data() {
        return {
            dataSources: ['Unity', 'Yardi'],
            table: {
                tempSearch: '',
                loading: false,
                headers: [
                    { text: 'Id', value: 'id'},
                    { text: 'Source', value: 'source' },
                    { text: 'Name', value: 'name'}, 
                    { text: 'Date Created', value: 'dateCreated' },
                    { text: 'Last Updated', value: 'lastUpdated' },
                    { text: 'Source Created', value: 'sourceCreationDate' },
                    { text: 'Source Updated', value: 'sourceLastUpdated' },
                    { text: 'Last Synced', value: 'lastSync' }
                ],
                items: [] as DataSyncMetadata[],
                totalRecords: -1,
                sortBy: '',
                sortDesc: false,
                pageIndex: 1,
                pageSize: 10,
                search: {
                    keywords: '',
                    pageIndex: 1,
                    pageSize: 10,
                    order: '',
                    timeZoneOffsetInMinutes: -420
                }
            },
            upsertDataSourceForm: generateUpsertInitialDataSourceForm(),
            genericErrorMessage,
            debouncedLoadData: () => undefined as any
        }
    },
    async mounted() {
        this.debouncedLoadData = debounce(this.loadData, 500).bind(this)
        await this.debouncedLoadData()
    },
    methods: {
        async onSearch() {
            this.table.search.keywords = this.table.tempSearch
            this.table.search.pageIndex = 1
            this.table.pageIndex = 1
            await this.debouncedLoadData()
        },
        async onClearSearch() {
            this.table.tempSearch = ''
            this.table.search.keywords = ''
            await this.debouncedLoadData()
        },
        onManageDataSources()  {
            this.upsertDataSourceForm = generateUpsertInitialDataSourceForm()
            this.upsertDataSourceForm.dialog = true
        },
        async loadData() {
            this.table.loading = true
            try {
                const response = await dataSyncService.getData(this.table.search)
                this.table.items = response.result.records
                this.table.totalRecords = response.result.totalRecords
            } catch(e) {
                // Handle Error
                console.error('Error loading data sync records', e)
            } finally {
                this.table.loading = false
            }
        },
        async onSave() {
            this.upsertDataSourceForm.steps[3].error = ''
            this.upsertDataSourceForm.steps[3].loading = true
            try {
                await dataSyncService.upsertDataSource(this.upsertDataSourceForm.dataSyncData)
                this.upsertDataSourceForm.steps[3].success = true
                await this.debouncedLoadData()
                this.upsertDataSourceForm.dialog = false
            } catch(_) {
                this.upsertDataSourceForm.steps[3].error = genericErrorMessage
                return
            } finally {
                this.upsertDataSourceForm.steps[3].loading = false
            }
        },
        onStepperBack() {
            this.upsertDataSourceForm.steps[1].error = ''
            this.upsertDataSourceForm.steps[2].error = ''
            this.upsertDataSourceForm.steps[3].error = ''
            this.upsertDataSourceForm.step -= 1
        },
        async onFirstStepContinue() {
            this.upsertDataSourceForm.steps[1].error = ''
            if(!this.upsertDataSourceForm.source) {
                this.upsertDataSourceForm.steps[1].error = 'Please select a data source to continue.'
                return
            }

            this.upsertDataSourceForm.steps[1].loading = true

            try {               
                this.upsertDataSourceForm.dataSyncData = await dataSyncService.getDataBySource(this.upsertDataSourceForm.source)
                this.upsertDataSourceForm.originalSyncedData = JSON.parse(JSON.stringify(this.upsertDataSourceForm.dataSyncData.syncedData))
                this.upsertDataSourceForm.dataSyncData.syncedData = this.upsertDataSourceForm.dataSyncData.syncedData.filter( (data: DataSyncMetadata) =>  {
                    return this.upsertDataSourceForm.dataSyncData.availableData.some( avail => avail.id === data.id)
                })

                this.upsertDataSourceForm.steps[1].success = true
                this.upsertDataSourceForm.step = 2
            } catch(_) {
                this.upsertDataSourceForm.steps[1].error = genericErrorMessage
            } finally {
                this.upsertDataSourceForm.steps[1].loading = false
            }
            
        },
        handleSortChange(sortBy: string, sortDesc: boolean) {
            let header = this.table.headers.find( header => header.value === sortBy )
            this.table.search.order = `${(header && header.text) || 'Id' } ${sortDesc ? 'desc' : ''}`
        }
    },
    computed: {
        dataToBeAdded(): DataSyncMetadata[] {
            if(this.upsertDataSourceForm.source) {
                return this.upsertDataSourceForm.dataSyncData.syncedData.filter( (exist: DataSyncMetadata) => {
                    return !this.upsertDataSourceForm.originalSyncedData.some(orig => orig.id === exist.id)
                })
            }
            return []
        },
        dataToBeDeleted(): DataSyncMetadata[] {
            if(this.upsertDataSourceForm.source) {
                return this.upsertDataSourceForm.originalSyncedData.filter( (orig: DataSyncMetadata) => {
                    return !this.upsertDataSourceForm.dataSyncData.syncedData.some(exist => exist.id === orig.id)
                })
            }
            return []
        },
        dataToBeRetained(): DataSyncMetadata[] {
            if(this.upsertDataSourceForm.source) {
                return this.upsertDataSourceForm.originalSyncedData.filter( (orig: DataSyncMetadata) => {
                    return this.upsertDataSourceForm.dataSyncData.syncedData.some(exist => exist.id === orig.id)
                })
            }
            return []
        }
    },
    watch: {
        'table.pageIndex': async function(newVal: number) {
            this.table.search.pageIndex = newVal
            await this.debouncedLoadData()
        },
        'table.pageSize': async function(newVal: number) {
            this.table.search.pageSize = newVal
            await this.debouncedLoadData()
        },
        'table.sortBy': async function(newVal: string) {
            this.handleSortChange(newVal, this.table.sortDesc)
            await this.debouncedLoadData()
        },
        'table.sortDesc': async function(newVal: boolean) {
            this.handleSortChange(this.table.sortBy, newVal)
            await this.debouncedLoadData()
        }
    }
})
